import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useAutoTabSwitch = ({ items, updateFilters }) => {
  const [_, setSearchParams] = useSearchParams();

  useEffect(() => {
    let buffer = '';
    let timeout;

    const applyChange = () => {
      const index = parseInt(buffer, 10) - 1;
      if (!isNaN(index) && index >= 0 && index < items.length) {
        const selectedItem = items[index];
        setSearchParams((prev) => {
          const newParams = new URLSearchParams(prev);
          if (selectedItem?.value === null) {
            newParams.delete('view');
          } else {
            newParams.set('view', selectedItem?.value);
          }
          return newParams;
        });
        updateFilters(null);
      }

      buffer = '';
    };

    const handleKeyDown = (e) => {
      if (/^Digit\d$/.test(e.code) && e.altKey) {
        e.preventDefault();
        clearTimeout(timeout);
        buffer += e.code.slice(-1);

        timeout = setTimeout(() => {
          applyChange();
        }, 0);
      }
    };

    const handleKeyUp = (e) => {
      if (!/^Digit\d$/.test(e.code) || !e.altKey) {
        buffer = '';
        clearTimeout(timeout);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      clearTimeout(timeout);
    };
  }, [setSearchParams, items]);
};
